import { CustomAttributeTranslationProperties } from './customAttributesTranslationProperties';

export class CustomAttributeOptionTranslations {

  // Identification
  public _id: string | undefined;

  // Properties
  public option : string | undefined;
  public translations : Array<CustomAttributeTranslationProperties> | undefined;
}
